<template>
  <div class="recruit" style="padding-top:0.48rem">
    <div class="nav-bar">
      <img class="icon-return" @click="goBack" src="~/assets/recruit/return.png" alt="">
      {{step === 1 ? '招募要求' : step === 2 ? '填写问卷' : '提交成功'}}
    </div>
    <div class="recruit-rule" v-show="step === 1 || step === 'fail'">
      <div class="rule-row">
        <div class="title">1.品味游戏，用心经营</div>
        <div class="desc">确保每天都有充足的时间在游戏圈内活跃与管理；</div>
      </div>
      <div class="rule-row">
        <div class="title">2.答疑解惑，有问必答</div>
        <div class="desc">积极解答游戏圈内玩家问题，用心帮助每一位疑惑的小伙伴；</div>
      </div>
      <div class="rule-row">
        <div class="title">3.安利游戏，分享攻略</div>
        <div class="desc">每日能够发布丰富、有趣的实况视频、游戏攻略、图文话题等；</div>
      </div>
      <div class="rule-row">
        <div class="title">4.认真负责，共建和谐氛围</div>
        <div class="desc">积极关注负责的游戏资讯、公告等，并做到文明互动遵守乐园版规；</div>
      </div>
      <div class="footer-button btn-active" @click="qualified">下一步</div>
    </div>
    <div class="recruit-question" v-if="step === 2">
      <div class="question-row">
        <div class="sort need">1</div>
        <div class="question">您的QQ号是多少？<span>(填空)</span></div>
        <div class="question-desc">请如实填写，方便工作人员联系</div>
        <div class="answer">
          <van-field v-model="form.qqNumber" clearable type="number" label="" placeholder="请输入QQ号码" />
        </div>
      </div>
      <div class="question-row">
        <div class="sort need">2</div>
        <div class="question">你今年几岁啦？<span>(填空)</span></div>
        <div class="answer">
          <van-field clearable type="number" v-model="form.age" label="" placeholder="请输入年龄" />
        </div>
      </div>
      <div class="question-row">
        <div class="sort need">3</div>
        <div class="question">日常使用233乐园的时长大概在？<span>(选择)</span></div>
        <div class="question-desc">请如实填写每日在线时长，已供官方审核</div>
        <div class="answer">
          <van-radio-group v-model="form.useTime">
            <div class="radio-row" @click="form.useTime = '0-1小时'">
              <van-radio icon-size="0.18rem" name="0-1小时" checked-color="#ff5500">0-1小时</van-radio>
            </div>
            <div class="radio-row"  @click="form.useTime = '1-3小时'">
              <van-radio icon-size="0.18rem" name="1-3小时" checked-color="#ff5500">1-3小时</van-radio>
            </div>
            <div class="radio-row"  @click="form.useTime = '3-5小时'">
              <van-radio icon-size="0.18rem" name="3-5小时" checked-color="#ff5500">3-5小时</van-radio>
            </div>
            <div class="radio-row"  @click="form.useTime = '5小时以上'">
              <van-radio icon-size="0.18rem" name="5小时以上" checked-color="#ff5500">5小时以上</van-radio>
            </div>
          </van-radio-group>
        </div>
      </div>
      <div class="question-row">
        <div class="sort need">4</div>
        <div class="question">你想要申请的游戏圈是？<span>(选择)</span></div>
        <div class="question-desc">友情提示：目前所有论坛均可申请圈主，尽量选择自己擅长并暂无圈主的游戏圈进行申请会更容易通过招募进入实习哦~</div>
        <div class="answer">
          <van-field :right-icon="showPicker ? 'arrow-down' : 'arrow'" readonly clearable v-model="form.gameCircleName" label="" placeholder="请选择游戏圈" @click="showPicker = !showPicker" />
          <div class="boxShadow" v-show="showPicker">
            <van-field style="border:none" :right-icon="showPicker ? 'arrow-down' : 'arrow'" readonly clearable v-model="form.gameCircleName" label="" placeholder="请选择游戏圈" @click="showPicker = !showPicker" />
            <div class="picker-list">
              <div @click="onConfirm(item)" :class="form.gameCircleName === item.gameCircleName ? 'picker-list-row-active' : ''" v-for="item in gameCircleList" :key="item.id" :value="item.gameCircleId" class="picker-list-row"><span>{{item.gameCircleName}}</span></div>
            </div>
          </div>
        </div>
      </div>
      <div class="question-row">
        <div class="sort need">5</div>
        <div class="question">是否有当任其他论坛、贴吧等社区的管理经验？<span>(填空)</span></div>
        <div class="question-desc">如实填写，有请填写论坛全称，无请填写无</div>
        <div class="answer">
          <van-field style="border-radio:0.05rem" clearable v-model="form.hasExp" label="" placeholder="请输入论坛名称" />
        </div>
      </div>
      <div class="question-row">
        <div class="sort need">6</div>
        <div class="question">你想申请圈主的理由是？<span>(填空)</span></div>
        <div class="answer">
          <van-field maxlength="200" show-word-limit style="border-radio:0.05rem" type="textarea" clearable v-model="form.reason" label="" placeholder="请输入理由" />
        </div>
      </div>
      <div class="question-row">
        <div class="sort">7</div>
        <div class="question">对于233游戏圈，你有什么建议或者意见想跟我们说的？<span>(选填)</span></div>
        <div class="question-desc">大胆说，畅所欲言，说不定明天打开233乐园就会有你所想的改变哦！</div>
        <div class="answer">
          <van-field maxlength="200" show-word-limit style="border-radio:0.05rem" type="textarea" clearable v-model="form.advise" label="" placeholder="请输入意见" />
        </div>
      </div>
      <van-button class="footer-button" @click="addCircleLeaderApply" :loading="loading" type="info" loading-text="提交中...">提 交</van-button>
    </div>
    <div class="recruit-result" v-if="step === 3">
      <img class="icon-wait" src="~/assets/recruit/icon-wait.png" alt="">
      <div class="result-title">审核已提交</div>
      <div class="result-sec-title">恭喜小伙伴成功申请游戏圈主资格</div>
      <div class="result-info">报名信息将由工作人员审核，结果将会在消息中心通知你，请耐心等待~预计审核时间1-3个工作日</div>
      <div class="footer-button btn-active" @click="closePage">完 成</div>
    </div>
    <div v-show="step === 'fail'" class="mask">
      <div class="tip-model">
        <div class="tip-model-title">申请失败</div>
        <div class="tip-model-desc">申请圈主需要在游戏圈发布一篇攻略、视频或者话题分享帖哦~</div>
        <div class="tip-model-determine model-btn" @click="jumpToTopic">如何发帖?</div>
        <div class="tip-model-cancel model-btn" @click="closeModel">关闭</div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { Field, RadioGroup, Radio, Popup, Picker, Button, Toast } from "vant";
import config from "@/../config";
import active from '@/utils/axios/index'
import primaryApi from "@/utils/primaryApi";
Vue.use(Field);
Vue.use(RadioGroup);
Vue.use(Radio);
Vue.use(Popup);
Vue.use(Picker);
Vue.use(Button);
Vue.use(Toast);
export default {
  components: {

  },
  data() {
    return {
      loading:false,
      showPicker:false,
      step:1,
      uuid:'',
      gameCircleId:'',
      form:{
        qqNumber:'',
        age:'',
        useTime:'',
        gameCircleName:'',
        hasExp:'',
        reason:'',
        advise:'',
      },
      userInfo:'',
      gameCircleList: [],
    }
  },
  mounted(){
    document.body.scrollIntoView()
    this.$tea("event_recruit_condition_show", {}); // 招募要求页面_展示
    this.gameCircleId = this.$route.query.gameCircleId
    this.form.gameCircleName = this.$route.query.gameCircleName
    window.nativeLogin = this.nativeLogin
    this.nativeLogin();
    this.appGameCircleApplyList()
  },
  methods:{
    nativeLogin() {
      this.userInfo = JSON.parse(primaryApi.getUserInfo());
      this.uuid = primaryApi.isSource == "sg" ? this.userInfo.uuid : this.userInfo.uuId;
      var onlyId = this.userInfo.onlyId;
      var userName = this.userInfo.userName;
      this.$store.commit({
        type: "setuuid",
        uuid:this.uuid,
      });
      this.$store.commit({
        type: "setonlyid",
        onlyId,
      });
      this.$store.commit({
        type: "setuserName",
        userName,
      });
    },
    closePage(){
        this.$tea("event_recruit_retult_finish", {}); // 报名成功页面_完成_点击
        var obj = {};
        obj.method = 'closeActivity';
        obj.param  = null;
        obj.asyncCallback = ''; //指定回调函数
        MetaX.exec(JSON.stringify(obj))
    },
    jumpToTopic(){
      this.$tea("event_recruit_fail_model_confirm", {}); // 申请失败弹窗_如何发帖_点击
      window.location.href = `metaapp://233xyx/article/detail?EXTRA_RES_ID=SMSOT_gmask_8f501344a9994b2db06c2569f7602f23`
    },
    closeModel(){
      this.$tea("event_recruit_fail_model_close", {}); // 申请失败弹窗_关闭_点击
      this.step = 1
    },
    goBack(){
      if(this.step === 1 || this.step === 'fail'){
          this.$tea("event_recruit_form_return", {}); // 招募要求页面_返回_点击
          this.$nextTick(_ =>{
            this.$router.go(-1)
          })
      }
      if(this.step === 2){
          this.step--
          this.$tea("event_recruit_form_return", {}); // 招募要求页面_返回_点击
      }
      if(this.step === 3){
          this.step--
          this.$tea("event_recruit_result_return", {}); // 报名成功页面_返回_点击
      }
    },
    qualified(){
      if(JSON.parse(JSON.parse(MetaX.exec(JSON.stringify({method:'getUserInfo',param:'',asyncCallback:''}))).data).isGuest){
        var obj = {};
        obj.method = 'popCommunityLoginDialog';
        obj.param  = null;
        obj.asyncCallback = ''; //指定回调函数
        MetaX.exec(JSON.stringify(obj))
        return
      }
      this.$tea("event_recruit_condition_next_step", {}); // 招募要求页面_下一步_点击
      active.qualified(config.API_HOST +  '/apiserv/Frontend/FeedRepository/circle/qualified',{uuid:this.uuid}).then(data =>{
        if(data.data === 0){
          this.step = 'fail'
          this.$tea("event_recruit_fail_model_show", {}); // 申请失败弹窗_展示
        }else if(data.data === 1){
          this.$tea("event_recruit_form_show", {}); // 填写问卷页面_展示
          this.step = 2
        }
      })
    },
    onConfirm(value) {
      this.gameCircleId = value.gameCircleId
      this.form.gameCircleName = value.gameCircleName
      this.showPicker = false;
    },
    appGameCircleApplyList(){
      active.appGameCircleApplyList(config.API_HOST +  '/apiserv/Frontend/FeedRepository/circle/appGameCircleApplyList',{}).then(data =>{
        this.gameCircleList = data.data
      })
    },
    addCircleLeaderApply(){
      if(!this.valitaForm()){
        Toast('请填写完整的申请信息');
        return
      }
      this.loading = true
      const params = {
        gameCircleId:this.gameCircleId,
        content:JSON.stringify(this.form),
        uuid:this.uuid
      }
      this.$tea("event_recruit_form_submit", {}); // 写问卷页面_提交_点击
      active.addCircleLeaderApply(config.API_HOST +  '/apiserv/Frontend/FeedRepository/circle/addCircleLeaderApply',params).then(params =>{
        this.$tea("event_recruit_result_show", {}); // 报名成功页面_展示
        this.step = 3
        this.loading = false
      }).catch(err =>{
        this.loading = false
      })
    },
    valitaForm(){
      const array = Object.keys(this.form)
      for(let i = 0;i< array.length; i++){
        if(!this.form[array[i]] && array[i] !== 'advise'){
          return false
        }
      }
      return true
    }
  }
}
</script>
<style scoped>
.recruit-result{
  padding: 0 32px;
}
.icon-wait{
  width: 64px;
  height: 64px;
  margin: 60px auto 20px auto;
  display: block;
}
.result-title{
  text-align: center;
  font-size: 20px;
  line-height: 36px;
  color: #333;
  font-weight: bold;
}
.result-sec-title{
  font-size: 16px;
  line-height: 24px;
  text-align: center;
  color: #1c1c1c;
}
.result-info{
  font-size: 16px;
  color: #999;
  text-align: center;
  margin-top: 24px;
}
.recruit{
  width: 100%;
  /* height: 100vh; */
  /* overflow: auto; */
  position: relative;
  background: white;
}
.nav-bar{
  width: 100%;
  height: 48px;
  line-height: 48px;
  text-align: center;
  font-size: 18px;
  color: #1c1c1c;
  font-weight: bold;
  position: fixed;
  border-bottom: #EEEEEE 1px solid;
  background: white;
  z-index: 100;
  top: 0;
}
.icon-return{
  width: 24px;
  height: 24px;
  position: absolute;
  left: 9px;
  top: 12px;
}
.rule-row{
  margin-top: 20px;
  padding: 0 30px;
}
.rule-row .title{
  color: #333;
  font-size: 16px;
  line-height: 32px;
  font-weight: bold;
}
.rule-row .desc{
  line-height: 24px;
  color: #666;
  font-size: 16px;
}
.footer-button{
  width: 315px;
  height: 44px;
  border-radius: 24px;
  text-align: center;
  line-height: 44px;
  color: white;
  background: #ff5500;
  font-size: 16px;
  font-weight: bold;
  margin: 90px auto 0 auto;
  border: none;
}
.recruit-question .footer-button{
  margin-top: 60px;
}
.btn-active:active {
  transform: scale(0.9)
}
.recruit-question{
  background: #f8f8f8;
  padding: 20px 30px 40px 30px;
}
.question-row{
  margin-bottom: 32px;
  padding-left: 40px;
  position: relative;
}
.question{
  font-size: 18px;
  color: #333;
  line-height: 24px;
}
.question span{
  color: #999;
  font-size: 12px;
}
.question-desc {
  color: #999;
  font-size: 12px;
  line-height: 20px;
}
.sort{
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: white;
  font-size: 15px;
  color: #333;
  text-align: center;
  line-height: 32px;
  position: absolute;
  left: 0;
  top: 0;
}
.need::after{
  content: "";
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #ff5500;
  position: absolute;
  right: 0;
  top: 0;
  transform: scale(0.4);
}
.answer{
  padding-top: 16px;
  position: relative;
}
.radio-row{
  margin-top: 8px;
  padding: 17px 14px;
  background: white;
  border-radius: 5px;
}
.mask{
  width: 100%;
  height: calc(100% - 48px);
  position: fixed;
  background: rgba(0,0,0,0.65);
  left: 0;
  top: 48px;
  z-index: 999;
}
.tip-model{
  width: 280px;
  padding: 20px;
  background: white;
  position: absolute;
  top: 240px;
  left: calc(50% - 140px);
  border-radius: 12px;
}
.tip-model-title{
  text-align: center;
  font-size: 18px;
  color: #333333;
  font-weight: bold;
}
.tip-model-desc{
  margin-top: 8px;
  text-align: center;
  font-size: 14px;
  color: #666666;
}
.tip-model-cancel{
  width: 114px;
  height: 44px;
  margin-top: 20px;
  float: left;
  color: #4A4A4A;
  text-align: center;
  font-size: 16px;
  border-radius: 22px;
  background: #F2F2F2;
  line-height: 44px;
  padding-left: 2px;
}
.tip-model-determine{
  width: 114px;
  height: 44px;
  margin-top: 20px;
  float: right;
  color: white;
  text-align: center;
  font-size: 16px;
  border-radius: 22px;
  background: #FF5000;
  line-height: 44px;
  padding-left: 2px;
}
.model-btn:active{
  transform: scale(0.9);
}
.boxShadow{
    box-shadow: 0px 2px 7px 0px rgba(0,0,0,0.16);
    position: absolute;
    top: 16px;
    left: 0;
    width: 100%;
    z-index: 22;
}
.picker-list{
  position: relative;
  width: calc(100% - 2px);
  max-height: 220px;
  overflow-y: auto;
  background: white;
  /* padding: 0 10px; */
  transform: translateX(1px);
}
.picker-list-row{
  width: 100%;
  height: 44px;
  line-height: 44px;
  color: #666666;
  position: relative;
}
.picker-list-row span{
  font-size: 12px;
  padding: 0 10px;
}
.picker-list-row::after{
  content: '';
  width: 200%;
  height: 1px;
  background-color: #EEEEEE;
  position: absolute;
  left: -50%;
  bottom:0;
  transform: scale(0.5);
}
.picker-list .picker-list-row:last-child::after{
  display: none;
}
.picker-list-row:hover{
  color:#ff5500;
  background: #F1F1F1;
}
.picker-list-row-active{
  color:#ff5500;
  background: #F1F1F1;
}
.van-field{
  border: solid 1px #E2E2E2;
  border-radius: 4px;
}
</style>
